import { AppPageEnum, TooltipNameEnum } from "app/shared/enums";
import { tTooltipRequest } from "app/types/tooltip.type";

export class TooltipModel {
    // skipcq: JS-0323
    elementTarget: any;
    // skipcq: JS-0323
    target: any;
    id?: string;
    content!: string;
    page?: AppPageEnum;
    name?: TooltipNameEnum | string; 
    company_id?: number; 
    editable = true;

    // skipcq: JS-0323
    constructor(elementTarget?: any,
        data?: Partial<TooltipModel>) {        
        if (data) {
            Object.assign(this, data);
        }

        if (elementTarget) {
            this.elementTarget = elementTarget;
            if (typeof (this.elementTarget) === 'string') {
                this.target = `#${this.elementTarget}`;
            } 
            else this.target = this.elementTarget;
        }

        if (this.page === AppPageEnum.ReconciliationReport) {
            this.editable = false;
        }
    }

    toRequest(): tTooltipRequest {
        return {
            content: this.content as string,
            page: this.page as AppPageEnum,
            name: this.name as TooltipNameEnum, 
            company_id: this.company_id as number, 
        }
    }
}

export class ShowTooltipModel<T> {
    // skipcq: JS-0323
    evt!: any;
    data!: T;

    // skipcq: JS-0323
    constructor(evt: any, data: T) {
        this.evt = evt;
        this.data = data;
    }
}